<template>
  <div class="performance-detail">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-wrapper">
          <h1>班主任业绩详情</h1>
          <span class="subtitle">{{ adviserName }}</span>
        </div>
        <Button @click="goBack" icon="ios-arrow-back">返回班主任龙虎榜</Button>
      </div>
    </div>
    <!-- 搜索条件 -->
    <Card class="search-card">
      <Form :model="queryParam" :label-width="80" inline>
        <Row>
          <Col  :xs="24" :sm="12" :md="6">
            <FormItem label="月份">
              <DatePicker
                type="month"
                format="yyyy-MM"
                placeholder="选择月份"
                :value="queryParam.month"
                @on-change="onMonthChange"
                style="width: 100%"
              />
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="12" :md="6">
            <FormItem label="师资" prop="tchChannel">
              <Select
                v-model="queryParam.tchChannel"
                placeholder="请选择师资"
                clearable
                @on-change="search"
                style="width: 100%">
                <Option
                  v-for="item in $constant.tchChannel"
                  :key="item.code"
                  :value="item.code">
                  {{ item.text }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col  :xs="24" :sm="12" :md="6">
            <Button type="primary" @click="search" :loading="searchLoading">
              <Icon type="ios-search" /> 搜索
            </Button>
            <Button type="primary" :loading="exportLoading" @click="exportData" style="margin-left: 10px;">
              <Icon type="ios-download" /> 导出
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>

    <!-- 数据表格 -->
    <Card class="table-card">
      <div class="table-wrapper" v-if="tableData.length > 0">
        <table class="data-table">
          <thead>
            <tr>
              <th>成交日期</th>
              <th>报名时间</th>
              <th>学生ID</th>
              <th>姓名</th>
              <th>收费</th>
              <th>基础课时</th>
              <th>赠送课时</th>
              <th>师资</th>
              <th>课程顾问</th>
              <th>班主任</th>
              <th>订单类型</th>
              <th>渠道</th>
              <th>转介绍</th>
              <th>转介绍学员班主任</th>
              <th>备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>{{ item.dealDate }}</td>
              <td>{{ item.signUpTime }}</td>
              <td>{{ item.userId }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ $numeral(item.amount).format('0,0') }}</td>
              <td>{{ item.baseHours }}</td>
              <td>{{ item.giftHours }}</td>
              <td>{{ item.teacherType }}</td>
              <td>{{ item.adviserName }}</td>
              <td>{{ item.studyAdviserName }}</td>
              <td :class="getChannelClass(item.channel)">{{ item.channel }}</td>
              <td>{{ item.regType }}</td>
              <td>{{ item.referralSC }}</td>
              <td>{{ item.referralSCName }}</td>
              <td>
                <Input
                  v-model="item.remark"
                  placeholder="请输入备注"
                  @on-change="handleRemarkChange(item)"
                  style="width: 200px;"
                />
              </td>
            </tr>
            <tr class="total-row">
              <td colspan="4"><strong>合计 {{ tableData.length }} 条</strong></td>
              <td><strong>{{ $numeral(totalAmount).format('0,0') }}</strong></td>
              <td colspan="10"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 空数据提示 -->
      <div v-if="tableData.length === 0 && !searchLoading" class="empty-data">
        <Icon type="ios-inbox" size="60" color="#dcdee2"/>
        <p>{{ noPermission ? '只能查看自己的业绩详情' : '暂无数据' }}</p>
        <Button v-if="noPermission" type="primary" @click="goBack">返回班主任龙虎榜</Button>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: 'StudyAdviserPerformanceDetail',
  data () {
    return {
      searchLoading: false,
      exportLoading: false,
      noPermission: false,
      queryParam: {
        month: this.$moment().format('YYYY-MM'),
        adviserId: '',
        tchChannel: 1
      },
      adviserName: '',
      tableData: []
    }
  },
  created () {
    // 从路由参数获取 adviserId 和 month
    const adviserId = this.$route.query.adviserId
    const month = this.$route.query.month

    if (adviserId) {
      this.queryParam.adviserId = adviserId
    }
    if (month) {
      this.queryParam.month = month
    }
    const tchChannel = this.$route.query.tchChannel
    if (tchChannel !== undefined && tchChannel !== null && tchChannel !== '') {
      this.queryParam.tchChannel = Number(tchChannel) || 1
    }

    this.search()
  },
  computed: {
    totalAmount () {
      return this.tableData.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
    }
  },
  methods: {
    onMonthChange (val) {
      this.queryParam.month = val
    },
    search () {
      this.searchLoading = true
      this.noPermission = false

      this.$http.get('/fundPackage/studyAdviserPerformanceDetail', {
        params: {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then(res => {
        if (res && res.status === 'ok' && res.data) {
          this.processData(res.data)
        } else {
          this.tableData = []
          this.adviserName = ''
          if (res && res.msg && String(res.msg).indexOf('无权限') !== -1) {
            this.noPermission = true
          }
        }
        this.searchLoading = false
      }).catch(() => {
        this.searchLoading = false
      })
    },
    processData (data) {
      if (!data) {
        this.tableData = []
        return
      }

      this.adviserName = data.adviserName || ''
      this.tableData = data.list || []
    },
    goBack () {
      this.$router.push({ path: '/order/studyAdviserDragonTiger' })
    },
    getChannelClass (channel) {
      if (!channel) return ''
      if (channel.includes('市场')) return 'channel-market'
      if (channel.includes('转介绍')) return 'channel-referral'
      if (channel.includes('结课新签')) return 'channel-renew'
      return ''
    },
    getFunctionClass (functionCover) {
      if (!functionCover) return ''
      if (functionCover.includes('补升')) return 'function-upgrade'
      if (functionCover.includes('续费')) return 'function-renew'
      return ''
    },
    handleRemarkChange (item) {
      // 防抖处理，避免频繁调用
      if (item.saveTimer) clearTimeout(item.saveTimer)
      item.saveTimer = setTimeout(() => {
        this.saveRemark(item)
      }, 500)
    },
    async saveRemark (item) {
      if (!item.fundPackageId) {
        this.$Message.warning('缺少 fundPackageId，无法保存')
        return
      }

      try {
        await this.$http.post('/fundPackage/updateRemark', {
          fundPackageId: item.fundPackageId,
          remark: item.remark || ''
        })
        this.$Message.success('备注已保存')
      } catch (error) {
        this.$Message.error('保存失败，请重试')
      }
    },
    exportData () {
      this.exportLoading = true

      this.$http.get('/fundPackage/studyAdviserPerformanceDetail/export', {
        responseType: 'arraybuffer',
        params: {
          month: this.queryParam.month,
          adviserId: this.queryParam.adviserId,
          tchChannel: this.queryParam.tchChannel || null
        }
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = `班主任业绩详情-${this.adviserName}-${this.queryParam.month}.xlsx`
          link.click()
          this.$Message.success('导出成功')
        } else {
          this.$Message.error(response.msg || '导出失败')
        }
        this.exportLoading = false
      }).catch((error) => {
        this.$Message.error('导出失败：' + error.message)
        this.exportLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.performance-detail {
  min-height: 100%;
  background: #f0f2f5;
  padding: 20px;
}

// 页面头部
.page-header {
  background: linear-gradient(135deg, #ff9900 0%, #ffb347 100%);
  border-radius: 12px;
  padding: 8px 12px;
  margin-bottom: 5px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;

    h1 {
      margin: 0;
      font-size: 28px;
      font-weight: 700;
      color: #fff;
      letter-spacing: 1px;
    }

    .subtitle {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.9);
      padding: 6px 16px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 20px;
    }
  }

  button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: #fff;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

// 表格卡片
.table-card {
  margin-top: 5px;

  .table-wrapper {
    overflow-x: auto;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    thead {
      tr {
        background: rgba(243, 239, 18, 0.87);
        color: #000;

        th {
          padding: 14px 12px;
          text-align: center;
          font-weight: 600;
          white-space: nowrap;
          border: none;
        }
      }
    }

    tbody {
      tr {
        transition: all 0.3s ease;

        &:hover {
          background: #f6f8fa;
          transform: scale(1.005);
        }

        td {
          padding: 12px;
          text-align: center;
          border-bottom: 1px solid #e8e8e8;
          white-space: nowrap;
        }
      }

      .total-row {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

        td {
          padding: 12px;
          font-size: 14px;
          border-bottom: none;
          font-weight: 600;
        }

        &:hover {
          transform: none;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }
      }
    }

    // 渠道选项样式
    .channel-market {
      color: #2d8cf0;
      font-weight: 600;
    }

    .channel-referral {
      color: #19be6b;
      font-weight: 600;
    }

    .channel-renew {
      color: #ff9900;
      font-weight: 600;
    }

    // 函数覆盖样式
    .function-upgrade {
      color: #f5576c;
      font-weight: 600;
    }

    .function-renew {
      color: #4facfe;
      font-weight: 600;
    }
  }

  .empty-data {
    text-align: center;
    padding: 60px 20px;
    color: #999;

    p {
      margin-top: 16px;
      font-size: 16px;
    }

    button {
      margin-top: 16px;
    }
  }
}

// 搜索条件卡片
.search-card {
  padding: 5px;
  margin-bottom: 5px;

  /deep/ .ivu-form-item {
    margin-bottom: 5px;
  }

  /deep/ .ivu-form-item-label {
    padding-right: 5px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .page-header {
    padding: 16px 20px;

    .title-wrapper {
      h1 {
        font-size: 22px;
      }
    }
  }

  .data-table {
    font-size: 13px;

    th, td {
      padding: 8px 6px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// StudyAdviserPerformanceDetail.vue?7d00e5f2